import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
 apiKey: "AIzaSyDjpYw7zlHeUwwADKXAffp8FwLyaVwoDSA",
  authDomain: "pubchat-8d240.firebaseapp.com",
  databaseURL: "https://pubchat-8d240-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "pubchat-8d240",
  storageBucket: "pubchat-8d240.firebasestorage.app",
  messagingSenderId: "447629372841",
  appId: "1:447629372841:web:fdf71454868b804bfb68b8",
  measurementId: "G-PTR442H45G"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);

export const signInWithGoogle = () =>
  signInWithPopup(auth, provider);
